import { Language, PhotoRequestTabTypes } from '^/types';

const { ALL, DRAFT, REQUESTED, COMPLETED }: typeof PhotoRequestTabTypes = PhotoRequestTabTypes;

export default {
  [ALL]: {
    [Language.EN_US]: 'All',
    [Language.KO_KR]: '전체',
  },
  [DRAFT]: {
    [Language.EN_US]: 'Draft',
    [Language.KO_KR]: '초안',
  },
  [REQUESTED]: {
    [Language.EN_US]: 'Requested',
    [Language.KO_KR]: '요청중',
  },
  [COMPLETED]: {
    [Language.EN_US]: 'Completed',
    [Language.KO_KR]: '완료됨',
  },
};
